import Vue from 'vue'
import vuexI18n from 'vuex-i18n'
import store from '@/store'
import en from '@/locales/en'
import tw from '@/locales/zh-Hant'

Vue.use(vuexI18n.plugin, store)

Vue.i18n.add('en', en)
Vue.i18n.add('zh-Hant', tw)

Vue.i18n.fallback('en')

const locale = localStorage.getItem('locale') || 'zh-Hant'

Vue.i18n.set(locale)
